import React from "react";
import { SFStack, SFUseStyled, SFIcons, SFTypography } from "@sf-core";

const { styled } = SFUseStyled();

const StyledStack = styled(SFStack)(({ theme }) => ({
  background: theme.palette.grey450.main,
  borderRadius: theme.spacing(0.5),
  width: "98%",
  padding: theme.spacing(1.5),
  marginRight: theme.spacing(1),
  cursor: "pointer",
  "&:hover": {
    background: "#3D3D4D"
  },
}));

const AddButton = ({ label, onClick }) => {

  return (
    <StyledStack direction="row" spacing={1} alignItems="center" onClick={onClick}>
      <SFIcons.SFAddCircleIcon color="blue300" />
      <SFTypography variant={"body2"}>
        {label}
      </SFTypography>
    </StyledStack>
  );
};

export default AddButton;
